import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { api } from '../../Api-Endpoints/apiEndpoint';
import ApiHandler from '../../ApiHandler';
import { shallowEqual, useSelector } from 'react-redux';
import Loader from '../Butten/Loader';
import toast from 'react-hot-toast';

const FeedbackModal = ({ showModal, setShowModal, procedure }) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useSelector(
    state => ({
      user: state.User.user,
    }),
    shallowEqual
  );

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    updateFolders();
  }, [showModal]);

  const updateFolders = async () => {
    try {
      setLoading(true);
      const { status, data } = await api.get(
        `/feedback/${user?._id}/${procedure?._id}`
      );
      console.log(data, 'Updated folder data');
      if (status == 200 && data.feedback.length > 0) {
        setFeedbacks(data?.feedback);
        setLoading(false);
      } else {
        setShowModal(false);
        toast.error('No feedback found for the procedure');
      }
    } catch (error) {
      console.error('Error updating folder:', error);
      // Optional: Show error feedback to the user
    }
  };

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={closeModal}
      contentLabel="Rename Folder"
      style={{
        content: {
          width: '50%',
          height: '50%',
          margin: 'auto',
          borderRadius: '20px',
          padding: 0,
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      }}
    >
      <div className="flex justify-between mx-5 my-3">
        <button onClick={closeModal}>
          <IoMdCloseCircleOutline size={20} />
        </button>
      </div>
      <hr />
      <div className="flex justify-center mx-5 my-3">
        <h2>Feedback of {procedure?.name}</h2>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="flex justify-end mx-5 my-3 gap-3">
          <table className="w-full px-10">
            <thead className="bg-gray-200 h-12 text-left">
              <tr>
                <th className="ps-5">S. NO.</th>
                <th>Description</th>
                <th>User</th>
              </tr>
            </thead>
            <tbody className="text-left">
              {feedbacks?.map((data, index) => (
                <tr key={index} className="h-[6vh] border-b">
                  <td className="ps-5">{index + 1}</td>
                  <td>{data?.description}</td>
                  <td>{`${data?.user.firstName || ''} ${data?.user.lastName || ''}`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  );
};

export default FeedbackModal;
